import type { QueryClient } from '@tanstack/react-query';

import { queryOptions } from '@tanstack/react-query';

import type { Project } from '@/api/core-api/types.gen';

import { researcherProjectsControllerFindOne } from '@/api/core-api';
import { queryKeys } from '@/hooks/api/query-keys';
import { getClient } from '@/utils/get-api-client';

export type GetResearcherProjectResponse =
  | { success: true; data: Project }
  | { success: false; error: string };

async function fetchResearcherProject(
  projectId: string,
  userId?: string,
): Promise<GetResearcherProjectResponse> {
  try {
    const response = await researcherProjectsControllerFindOne({
      client: getClient(userId),
      path: { projectId },
    });

    if (response.error || !response.data) {
      return { success: false, error: 'Failed to fetch project' };
    }

    return { success: true, data: response.data };
  } catch {
    return { success: false, error: 'Network error' };
  }
}

export const researcherProjectQueryOptions = (
  projectId: string,
  userId?: string,
) =>
  queryOptions({
    queryKey: queryKeys.researcherProjects.detail(projectId),
    queryFn: () => fetchResearcherProject(projectId, userId),
  });

export async function prefetchResearcherProject(
  queryClient: QueryClient,
  projectId: string,
  userId?: string,
): Promise<void> {
  await queryClient.ensureQueryData(
    researcherProjectQueryOptions(projectId, userId),
  );
}
